import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Subscribe from './Subscribe';

const Blog = () => {
    useEffect(() =>{
        document.title = "Blog | Earth VIII "
    },[])

    const [RotateDg, setRotateDg] = useState()  

    const rotateDgCSS = {
        transform: "rotate(-25deg)",
        transition: "transform 0.2s ease 0s"
      }

      const removerotateDgCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.2s ease 0s"
      }

      const rotatedg = () =>{
        setRotateDg(rotateDgCSS) 
    }
    const stoprotatedg = () =>{
        setRotateDg(removerotateDgCSS) 
    }



    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>

<div  class="apartmentsfirstbox">
<div class="container">
<div class="row">
<div class="col-md-6">
<img className="img-fluid" src="images/blog/blogthumbnail.png"/>

</div>

<div class="col-md-6">

<h3 className="blogherotitle blogherotitlesmallertitle mobilerow">Why and When You Should Invest in Real Estate in Nigeria
   
    </h3>
    <p className="blogherosubtitle blogherosubtitlesmallerscreen fordesktoponly">

    If you are looking for a safe investment option, then real estate should be top on your search list. Real Estate investments offer what is arguably the most robust investment choice. 
In Nigeria particularly, many people are awakening to the world of benefits available in real estate. You will meet some of them while reading this article.

       
         </p>
    
         <p className="blogherosubtitle formobileonly">

         If you are looking for a safe investment option, then real estate should be top on your search list. Real Estate investments offer what is arguably the most robust investment choice. 
In Nigeria particularly, many people are awakening to the world of benefits available in real estate. You will meet some of them while reading this article.         </p>


<div class="row">
    <div class="col-md-4">
    <p className="blogdate"> <img src="images/icons/calendar.png"/> 24 Jan, 2021</p>
        </div>

        {/* <div class="col-md-4">
    <p className="blogtime"> <img src="images/icons/calendar.png"/> 2 mins, 23 secs read</p>
        </div> */}
    </div>
    <a className="linkdecoration" target="_blank" href="/whyandwhenyoushouldinvestinrealestateinnigeria" >   <p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  className="learnmorecta hpblogreadmore">Continue reading <img className="icorotatediagonal" style={RotateDg}  src="images/rightarrow.png"/></p></a>

    

</div>
</div>


    </div>

    </div>


    <div class="container">
<div class="row ">

  
    <div class="row mobilerow">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-11 col-10" >
                       <h2 className="stepdown hmsecondboxtitle"> <span> Our latest articles here </span> <span style={{float:"right",fontSize:"12px"}}>                <a   className="linkdecoration fordesktoponly" target="_blank" href="/blog"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2">View more articles <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
</span></h2>
                    
                       {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                       </div>
                   

               </div>
   
<div class="col-md-6">
    <div class="row">
        <div class="col-md-4 col-4">
        <img className="img-fluid" src="images/blog/blogthumbnail1.png"/>

        </div>
        <div class="col-md-8 col-8">
        <p className="hpblogtitle hpblogtitlesmscreen">Why and When You Should Invest in <br/>Real Estate in Nigeria</p>
    <p className="hpblogbody fordesktoponly">
    If you are looking for a safe investment option, then real estate should be top on your search list. 


         </p>
         <p className="hpblogbodymobile formobileonly">

         If you are looking for a safe investment option, then real estate should be top on your search list. 
         Real Estate
     </p>

<a   className="linkdecoration hpblogreadmore fordesktoponly" target="_blank" href="/whyandwhenyoushouldinvestinrealestateinnigeria"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore">Continue reading article <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
    
<a   className="linkdecoration hpblogreadmore " target="_blank" href="/whyandwhenyoushouldinvestinrealestateinnigeria"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore formobileonly">Continue reading article </p></a>

        </div>
    </div>

</div>
{/* style={{height:"200px", width:"300px",borderRadius:"16px"}}  */}
   
<div class="col-md-6">
    <div class="row">
        <div class="col-md-4 col-4">
        <img className="img-fluid" src="images/blog/blogthumbnail1.png"/>

        </div>
        <div class="col-md-8 col-8">
        <p className="hpblogtitle hpblogtitlesmscreen">An Early Christmas Gift For You</p>
    <p className="hpblogbody fordesktoponly">
    The house you looked at today and wanted to think about until tomorrow may be the same house someone looked at yesterday and will buy today.”


         </p>
         <p className="hpblogbodymobile formobileonly">

         If you are looking for a safe investment option, then real estate should be top on your search list. 
              </p>

<a   className="linkdecoration hpblogreadmore fordesktoponly" target="_blank" href="/anearlychristmasgiftforyou"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore">Continue reading article <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
    
<a   className="linkdecoration hpblogreadmore" target="_blank" href="/anearlychristmasgiftforyou"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore formobileonly">Continue reading article </p></a>

        </div>
    </div>

</div>
</div>

<a  style={{textAlign:"center"}} className="linkdecoration formobileonly" target="_blank" href="/apartments"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 ">View more articles <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
    </div>

<Subscribe/>





    </div>






    <Footer/>
    </div>


    )
    
    
}


export {Blog as default}